export default __webpack_public_path__ + "static/media/img/revdojo.webp";